angular.module('homebot.directives', [])

  .directive('helpLink', function(){
    return {
      restrict: 'A',
      link: function(scope, el, attrs, undefined){

        el.on('click', function(e){
          var $target = $(el.attr('href'));

          $target.toggleClass('open');

          e.preventDefault();
        });
      }
    }
  })

  .directive('focusInput', function(){
    return {
      restrict: 'A',
      link: function(scope, el, attrs, undefined){
        attrs.$observe('focusInput', function(newVal){
          if(newVal === "true")
            $(el).find('input').first().focus();
        });
      }
    }
  })

  .directive('changeSubView', ['$rootScope', function($rootScope){
    return {
      restrict: 'A',
      link: function(scope, el, attrs){
        var subView = attrs.changeSubView || 'number-entry';
        el.on('click', function(e){
          $rootScope.$apply(function(){
            $rootScope.subView = subView;
          });
          e.stopPropagation();
          e.preventDefault();
        }).addClass('linked');
      }
    }
  }])

  .directive('subView', ['$rootScope', function($rootScope){
    return {
      restrict: 'A',
      link: function(scope, el, attrs){
        var thisView = attrs.subView;

        $rootScope.$watch('subView', changeView);

        el.on('click', function(){
          if($rootScope.subView === thisView) return;

          $rootScope.$apply(function(){
            $rootScope.subView = thisView;
          });
        });

        function changeView(newView, oldView, scroll){
          if(newView === oldView)
            return;

          if(newView !== thisView)
            return el.removeClass('active');

          el.addClass('active');

          $rootScope.subView = thisView;

          if(typeof scroll !== 'undefined' && scroll !== false)
            $('html, body').animate({scrollTop: $(el[0]).offset().top - 50}, 600);
        }

        if(typeof attrs.isDefaultSubView !== 'undefined')
          changeView(thisView, null, false);
      }
    }
  }])

  .directive('yearSelector', function(){
    return {
      restrict: 'A',
      template: function(){
        var html = '<option value=""></option>';
        var year = parseInt(moment().format('YYYY'));

        for(var i = year; i > year - 30; i--){
          html += '<option value="'+i+'">'+i+'</option>';
        }

        return html;
      }
    }
  })

  .directive('yearSelectorShort', function(){
    return {
      restrict: 'A',
      template: function(){
        var html = '<option value=""></option>';
        var year = parseInt(moment().format('YYYY'));

        for(var i = year; i > year - 3; i--){
          html += '<option value="'+i+'">'+i+'</option>';
        }

        return html;
      }
    }
  })

  .directive('monthSelector', function(){
    return {
      restrict: 'A',
      template: function(){
        var html = '<option value=""></option>';
        var months = moment.months();

        for(var i = 0; i < months.length; i++){
          html += '<option value="'+months[i]+'">'+months[i]+'</option>';
        }

        return html;
      }
    }
  })

  .directive('diySelector', ['$filter', 'PRINCIPAL_PAYMENT_OPTIONS', function($filter, PRINCIPAL_PAYMENT_OPTIONS){
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel) {
        ngModel.$parsers.push(function(val) {
          return parseInt(val, 10);
        });
        ngModel.$formatters.push(function(val) {
          return '' + val;
        });
      },
      template: function(){
        var html = '';
        var values = PRINCIPAL_PAYMENT_OPTIONS.slice()

        _.each(values, function(val){
          html += '<option value="'+val+'">'+$filter('money')(val)+'</option>';
        });

        return html;
      }
    }
  }])

  .directive('nightlyRoomSelector', ['$filter', function($filter){
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel) {
        ngModel.$parsers.push(function(val) {
          return parseInt(val, 10);
        });
        ngModel.$formatters.push(function(val) {
          return '' + val;
        });
      },
      template: function(){
        var html = '';
        var values = [50,75,100,125,150,200,250,300,350,400,450,500];

        _.each(values, function(val){
          html += '<option value="'+val+'">'+$filter('money')(val)+'/ngt</option>';
        });

        return html;
      }
    }
  }])

  .directive('nightlyHomeSelector', ['$filter', function($filter){
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel) {
        ngModel.$parsers.push(function(val) {
          return parseInt(val, 10);
        });
        ngModel.$formatters.push(function(val) {
          return '' + val;
        });
      },
      template: function(){
        var html = '';
        var values = [50,75,100,125,150,200,250,300,350,400,450,500,600,700,800,900,1000];

        _.each(values, function(val){
          html += '<option value="'+val+'">'+$filter('money')(val)+'/ngt</option>';
        });

        return html;
      }
    }
  }])

  .directive('termSelector', ['LOANTERMS', function(LOANTERMS){
    return {
      restrict: 'A',
      template: function(){
        var html = '<option value=""></option>';
        _.each(LOANTERMS, function(v,k){
          html += '<option value="'+k+'">'+v+'</option>';
        });

        return html;
      }
    }
  }])

  .directive('inputFocusHelper', function(){
    return {
      restrict: 'A',
      link: function(scope, el){
        var $el = $(el);

        $el.find('input').on('focus', function(){
          $el.addClass('focused');
        }).on('blur', function(){
          $el.removeClass('focused');
        });
      }
    }
  })

  .directive('coloredValue', ['HelperService', function(helpers){
    function updateEl(el, val, compareval){
      compareval = compareval || 0;

      if(parseFloat(val) < parseFloat(compareval))
        el.addClass('text-danger');
      else
        el.addClass('text-positive');
    };

    return {
      restrict: 'A',
      link: function(scope, el, attrs){
        var update = function(){ updateEl(el, attrs.coloredValue, attrs.coloredCompare); };

        attrs.$observe('coloredValue', update);
      }
    }
  }])

  .directive('twoBarCompare', ['$filter', '$window', function($filter, $window){
    function resize(scope, el){
      var largest = scope.barOne > scope.barTwo ? scope.barOne : scope.barTwo;
      var height = $(el).height();

      scope.barOneHeight = height / (largest/scope.barOne);
      scope.barTwoHeight = height / (largest/scope.barTwo);
    }

    function floorValsForAnimation(scope){
      scope.barOneHeight = 0;
      scope.barTwoHeight = 0;
    }

    return {
      restrict: 'A',
      template: function(){
        return '<div style="height:{{barOneHeight}}px"></div><div style="height:{{barTwoHeight}}px"></div>';
      },
      scope:{
        barOne: '@',
        barTwo: '@'
      },
      link: function(scope, el, attrs){
        var resizeBars = _.debounce(function(){
          resize(scope, el);
        }, 200);

        attrs.$observe('barOne', resizeBars);
        attrs.$observe('barTwo', resizeBars);
        $($window).on('resize', resizeBars);

        floorValsForAnimation(scope);
        resizeBars();
      }
    }
  }])

  .directive('percentBar', [function(){
    function setPercent(scope){
      var val = Math.abs(parseInt(scope.barval, 10));
      var compareval = Math.abs(parseInt(scope.compareval, 10));

      var largest =  val > compareval ? val : compareval;

      var barpercent = Math.abs(100 / (largest/val));

      scope.barstyle = { 'width': barpercent/2 + '%'};
    }

    return {
      restrict: 'A',
      scope:{
        barval: '@',
        compareval: '@'
      },
      template: function(el){
        return el.html();
      },
      link: function(scope, el, attrs){
        var setVals = function(){
          setPercent(scope);
        };

        attrs.$observe('barval', setVals);
        attrs.$observe('compareval', setVals);

        setVals();
      }
    }
  }])

  .directive('track', ['UtilService', function(utils){

    return{
      restrict: 'A',
      link: function(scope, el, attrs){
        var label = attrs.trackLabel || null;
        var eventName = attrs.track || 'UnNamedEvent';
        var eventType = el[0].nodeName === 'SELECT' ? 'change' : 'click';

        el.on(eventType, function(){
          utils.track(eventName, label);
        });
      }
    }
  }])

  .directive('animatedNumber', ['$filter', function($filter){
    var decimal_places = 2;
    var decimal_factor = decimal_places === 0 ? 1 : decimal_places * 10;

    var numberSteps = {
      money: $.animateNumber.numberStepFactories.separator(','),
      percent: function(now, tween) {
        $(tween.elem).text((now / decimal_factor).toFixed(decimal_places));
      }
    };

    function getNumber(number, numberType){
      if(numberType === 'percent')
        return number * decimal_factor;
      else
        return Math.round(number);
    }

    return {
      restrict: 'A',
      link: function(scope, el, attrs){
        var $el = $(el);
        var numberType = attrs.animatedNumber;
        var duration = attrs.fast !== undefined ? 250 : 1000;

        attrs.$observe('num', function(newVal){
          if(isNaN(newVal))
            return;
          var num = getNumber(newVal, numberType);
          var isNegative = num < 0;

          $el.toggleClass('number-negative', isNegative);

          num = Math.abs(num);

          $el.stop().animateNumber({
              number: num,
              numberStep: numberSteps[numberType]
            }, {
              duration: duration,
              easing: 'swing',
              complete: function(){
                $el.prop('number', num);
              }
            });

        });
      }
    }
  }])

  .directive('showOnScroll', function(){
    var $el, $visibleEl, winHeight, offsetTop, scrollTop;
    var rand = Math.floor(Math.random() * 10000);
    var $doc = $(document);

    var checkScroll = _.debounce(function(){
      winHeight = $(window).height();
      offsetTop = $el.offset().top;
      scrollTop = $doc.scrollTop();
      if(offsetTop - scrollTop < winHeight/2){
        $el.removeClass('force-closed');
        $doc.off('scroll.'+rand);
      }
    }, 200, {maxWait: 500});

    var link = function(scope, el, attrs){
      $el = $(el).addClass('force-closed');
      $doc.on('scroll.'+rand, checkScroll);
    };

    return {
      restrict: 'A',
      link: link
    };
  })

  .directive('saveInput', function(){
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        var model = attrs.ngModel.replace('home.', '').replace('statement.', '');
        var binding = elem[0].tagName.toLowerCase() === 'select' ? 'change' : 'keyup blur';

        elem.on(binding,function(e) {
          if(e.keyCode === 13 || e.type === 'blur' || e.type === 'change'){
            scope.checkAndSave(model, elem.val());
          }
        });
      }
    }
  })

  .directive('heightResize', function(){
    var $el;

    var resize = _.debounce(function(){
      $el.height(function(){
        var height = 0;
        $.each($el.children().not('.ng-hide'), function(){
          height += $(this).height();
        });
        return height;
      });
    }, 50);

    var link = function ($scope, el, attrs) {
      $el = $(el);
      attrs.$observe('heightResize', resize);
      $(window).on('resize', resize);
    };

    return {
      restrict: 'A',
      link: link
    }
  })

  .directive('loading', function(){
    return {
      restrict: 'A',
      link: function ($scope, el, attrs) {
        let isInitialLoad = true;
        var minWait = 1000;
        var startTime, currentTime;

        el.addClass('button-loading');
        $(el).wrapInner('<span>');

        function stopLoad(){
          currentTime = moment().format('x');

          _.delay(function(){
            el.removeAttr('disabled');
            el.removeClass('button-loading--activated');
          }, minWait - (currentTime-startTime));
        }

        attrs.$observe('loading', function(newVal){
          if(newVal === 'true'){
            startTime = moment().format('x');
            el.attr('disabled', 'disabled');
            el.addClass('button-loading--activated');
          }else{
            if(!isInitialLoad)
              stopLoad();
          }

          isInitialLoad = false;
        });
      }
    }
  })

  .directive('loader', function(){
    return {
      replace: true,
      restrict: 'E',
      template: '<div class="page-loader"></div>',
      link: function($scope, el){
        var totalDuration = 1500;
        var bars = 30;
        _.times(bars, function(i){
          var bar = document.createElement('div');
          el[0].appendChild(bar);
          _.delay(function(){ bar.classList.add('animated') }, totalDuration / bars * i);
        });
      }
    }
  })

  .directive('checkSupport', function(){
    return {
      restrict: 'A',
      link: function($scope, el, attrs){
        if('ontouchstart' in window)
          el.addClass('touch');
      }
    }
  })

  .directive('slider', ['$timeout', function($timeout){
    return {
      restrict: 'A',
      template: '<span class="slider-min">{{minLabel}}</span>'
                + '<div class="slider-main"></div>'
                + '<span class="slider-max">{{maxLabel}}</span>',
      scope: {
        ngModel: '='
      },
      link: function($scope, el, attrs){
        var slider = $(el).find('.slider-main')[0];
        var prepend = attrs.prepend || '';
        var append = attrs.append || '';
        var $tooltip = $('<div class="slider-tooltip"></div>');

        function minMaxClasses(){
          if(Math.round($scope.ngModel) === Math.round($scope.min))
            el.addClass('slider-at-min');
          else if(Math.round($scope.ngModel) === Math.round($scope.max))
            el.addClass('slider-at-max');
          else
            el.removeClass('slider-at-min slider-at-max');
        }

        function bindSlide(){
          slider.noUiSlider.on('update', function(values, handle, sliderVal){
            sliderVal = Math.round(sliderVal);

            if(sliderVal === $scope.ngModel) return;

            $tooltip.html(prepend+sliderVal+append);

            $timeout(function(){
              $scope.ngModel = sliderVal;
              minMaxClasses();
            });
          });
        }

        function setup(){
          if(slider.noUiSlider)
            slider.noUiSlider.destroy();

          $scope.min = attrs.min ? parseInt(attrs.min, 10) : 0;
          $scope.max = attrs.max ? parseInt(attrs.max, 10) : 100;
          $scope.minLabel = attrs.minLabel || $scope.min;
          $scope.maxLabel = attrs.maxLabel || $scope.max;

          if($scope.ngModel < $scope.min){
            $scope.ngModel = $scope.min;
          }

          noUiSlider.create(slider, {
            start: $scope.ngModel,
            range: {
              min: $scope.min,
              max: $scope.max
            },
          });

          setupTooltip();
          bindSlide();
          minMaxClasses();
        }

        function setupTooltip(){
          $tooltip
            .appendTo($(slider).find('.noUi-handle'))
            .html(prepend+$scope.ngModel+append)
        }

        function bindSettingsChange(){
          attrs.$observe('min', function(newVal){
            if($scope.min !== parseInt(newVal, 10)) setup();
          });

          attrs.$observe('max', function(newVal){
            if($scope.max !== parseInt(newVal, 10)) setup();
          });
        }

        setup();
        bindSettingsChange();
      }
    }
  }]);
